import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SignatureIcon = createIcon({
  displayName: 'SignatureIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <svg viewBox="0 0 24 24">
        <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
          <path d="M11 9.883v3.117h3.117l6.6-6.492c.396-.39.399-1.027.006-1.42l-1.812-1.812c-.393-.393-1.031-.39-1.42.006l-6.491 6.601Z" />
          <path d="M7 13h-2c-1.105 0-2 .895-2 2v0c0 1.105.895 2 2 2h14c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2h-4" />
        </g>
        <path fill="none" d="M0 0h24v24h-24Z" />
      </svg>
    </>
  ),
})

const Signature: FC<IconProps> = (props) => {
  return <CustomIcon as={SignatureIcon} {...props} />
}

export default memo(Signature)
